export default __webpack_public_path__ + "static/Metropolis-RegularItalic-6500caeabfc35a1e700628665b4e810f.woff2";